import { render, staticRenderFns } from "./PurchaseOrderCheckBox.vue?vue&type=template&id=1ea471e5&"
import script from "./PurchaseOrderCheckBox.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderCheckBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports